import React from "react";
import { Text, VStack, Icon } from "@chakra-ui/react";
import { BiLogOutCircle } from "react-icons/bi";
import ModalLayout from "../Layout/ModalLayout";

function LogoutModal({ isOpen, setIsOpen, onLogout }) {
  return (
    <ModalLayout
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Logout Confirmation"
      successBtnText="LOGOUT"
      cancelBtnText="CANCEL"
      rejectHandler={onLogout}
      size="sm"
    >
      <VStack spacing={4} py={4}>
        <Icon as={BiLogOutCircle} w={12} h={12} color="red.500" />
        <Text textAlign="center" fontSize="16px" fontWeight="500" color="gray.700">
          Are you sure you want to log out of your account?
        </Text>
        <Text textAlign="center" fontSize="14px" color="gray.500">
          You will need to sign in again to access the portal.
        </Text>
      </VStack>
    </ModalLayout>
  );
}

export default LogoutModal;
